import React from 'react';

/**
 * The site's mark: a mine, drawn as a circle with eight radiating legs — used
 * in the top bar and, as a static file, for the browser tab's favicon. Kept
 * in one place so the two never drift apart.
 *
 * Legs are drawn noticeably thicker than a typical line icon and the circle
 * is a touch larger relative to them, so the shape stays legible down at
 * favicon size instead of thinning out to a smudge.
 */
export function BrandMark({ className }: { className?: string }): React.ReactElement {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="6.6" fill="currentColor" />
      <g stroke="currentColor" strokeWidth="2.6" strokeLinecap="round">
        <path d="M12 2.2v2.8M12 19v2.8M2.2 12h2.8M19 12h2.8" />
        <path d="M5.1 5.1l2 2M16.9 16.9l2 2M18.9 5.1l-2 2M7.1 16.9l-2 2" />
      </g>
    </svg>
  );
}
